<div class="qs-answer mt-3 border-0 position-relative overflow-visible" [formGroup]="form">
  <div class="qs-body w-70">
    <div class="flex-grow-1 qs-card mb-2 c-pointer">
      <mat-card class="py-0" (click)="showChatBox()" [ngClass]="checkValid">
        <div class="d-flex pt-2">
          <div class="pe-2">{{questionIndex + 1}}.</div>
          <div class="flex-grow-1">
            <div class="d-flex">
              <p [attr.for]="question.key" [innerHTML]="question.questionHtml"></p>
            </div>
            <div class="d-flex flex-dir-column">
              <mat-form-field class="w-75" *ngIf="question.type === 'Short Answer'"  [floatLabel]="'never'">
                <input matInput formControlName="{{question.key}}" [placeholder]="question.placeholder">
                <mat-error *ngIf="!isValid" class="d-flex flex-dir-row text-danger">
                  <mat-icon class="fs-5">error_outline</mat-icon>
                  <div class="ms-2 mt-1 fw-bold">This is a required question</div>
                </mat-error>
              </mat-form-field>

              <mat-form-field *ngIf="question.type === 'Long Answer'"  [floatLabel]="'never'">
                                <textarea matInput formControlName="{{question.key}}"
                                          [placeholder]=question.placeholder
                                          class="qs-chat-textarea border-0 shadow-none bg-transparent"
                                          cdkTextareaAutosize
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="5">
                                </textarea>
                <mat-error *ngIf="!isValid" class="d-flex flex-dir-row text-danger">
                  <mat-icon class="fs-5">error_outline</mat-icon>
                  <div class="ms-2 mt-1 fw-bold">This is a required question</div>
                </mat-error>
              </mat-form-field>

              <div *ngIf="question.type === 'Multiple Choice'">
                <div class="radio-btn-style">
                <mat-radio-group class="d-flex flex-dir-column" aria-label="Select an option"
                                 formControlName="{{question.key}}">
                  <mat-radio-button class="m-2" *ngFor="let option of question.multipleOptions"
                                    [value]="option.id">{{option.value}}</mat-radio-button>
                </mat-radio-group>
                <mat-error *ngIf="question.mandatory && !isRadioValid && isTouched" class="d-flex flex-dir-row text-danger ms-1">
                  <mat-icon class="fs-5 mt-1">error_outline</mat-icon>
                  <div class="ms-2 mt-1 fs-7 fw-bold">This is a required question</div>
                </mat-error>
              </div>
              </div>

              <div *ngIf="question.type === 'Check Boxes'">
                <ng-container formArrayName="{{question.key}}">
                  <div class="d-flex flex-dir-column"
                       *ngFor="let checkbox of form.controls[question.key]['controls']; let i = index">
                    <mat-checkbox class="m-2" [formControlName]="i">
                      {{question.checkBoxes[i].value}}
                    </mat-checkbox>
                  </div>
                  <mat-error *ngIf="question.mandatory && !validCheckboxes && checkBoxUntouched" class="d-flex flex-dir-row text-danger ms-1">
                    <mat-icon class="fs-5 mt-1">error_outline</mat-icon>
                    <div class="ms-2 mt-1 fs-7 fw-bold">This is a required question</div>
                  </mat-error>
                </ng-container>
              </div>

              <mat-form-field class="w-30" *ngIf="question.type === 'Date'" [floatLabel]="'never'">
                <input matInput [matDatepicker]="dp1" placeholder="MM/DD/YYYY" formControlName="{{question.key}}">
                <mat-datepicker-toggle matSuffix [for]="dp1"></mat-datepicker-toggle>
                <mat-datepicker #dp1></mat-datepicker>
                <mat-error *ngIf="question.mandatory && !isValid" class="d-flex flex-dir-row text-danger">
                  <mat-icon class="fs-5">error_outline</mat-icon>
                  <div class="ms-2 mt-1 fs-7 fw-bold">This is a required question</div>
                </mat-error>
              </mat-form-field>

              <div *ngIf="question.type === 'Rating'">
                <lib-star-rating (onRatingChange)="setRating($event)" [ratingGiven]="question.ratingAnswer" [disable]="lock" ></lib-star-rating>
                <mat-error *ngIf="!isValid && isTouched" class="d-flex flex-dir-row text-danger">
                  <mat-icon class="fs-5 mt-1">error_outline</mat-icon>
                  <div class="ms-2 mt-1 fs-7 fw-bold">This is a required question</div>
                </mat-error>
              </div>
            </div>
          </div>
          <div class="d-flex flex-dir-column justify-content-between">
            <div class="fs-3 ms-1 fw-bolder text-dark-red align-self-start" *ngIf="question.mandatory">*</div>
          </div>
        </div>
        <div class="row question-section-attachment">
          <div class="columns medium-6 mb-2 mt-2" *ngFor="let file of question.attachments; let index = index">
            <div class="d-flex border shadow-sm p-2 rounded attach-border">
              <div class="text-truncate flex-grow-1 vw-20 fs-7" matTooltip="{{file.documentName}}">{{file.documentName}}</div>
              <mat-icon class="text-danger fs-6 pt-1" *ngIf="!lock && isCustomer" (click)="deleteFile(index, file)">delete_outline
              </mat-icon>
              <mat-icon class="text-secondary fs-6 pt-1" (click)="downloadDocument(file, 'download')">
                file_download
              </mat-icon>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div *ngIf="!lock" class="pt-1 w-100">
            <app-tpiq-file-upload (onFileUpload)="updateDocDetails($event)" [id]="question.questionId"></app-tpiq-file-upload>
          </div>
          <div class="d-flex justify-content-end align-items-end">
            <mat-icon class="text-secondary fs-6 ps-1 mt-1" (click)="showChatBox()" *ngIf="question.comments.length === 0">chat_bubble_outline</mat-icon>
            <mat-icon class="text-secondary fs-6 ps-1 mt-1" (click)="showChatBox()" *ngIf="question.comments.length > 0" matBadge="{{question.comments.length}}" matBadgeSize="small" matBadgeColor="accent">chat_bubble_outline</mat-icon>
          </div>
        </div>
      </mat-card>
    </div>
  </div>
  <div class="qs-chat-box w-30 position-absolute top-0 end-0 z-999 ps-3 pe-2 mb-3" *ngIf="question.showComments">
    <mat-card class="p-0">
      <mat-card-header class="bg-light-gray py-1 ps-3 rounded-top">
        <mat-card-title class="fs-7 text-primary mb-0">Comments</mat-card-title>
      </mat-card-header>
      <div class="d-flex flex-dir-column px-3" *ngIf="question.comments.length > 0">
        <div class="mt-2 post-box" *ngFor="let comment of question.comments; let index = index">
          <mat-card-header class="d-flex">
            <div mat-card-avatar class="position-relative h-rem-6 w-rem-6" [style.background-color]="user.colorCode">
              <div class="position-absolute text-white top-50 start-50 translate-middle fs-8">{{comment.user.firstName.charAt(0)}}{{comment.user.lastName.charAt(0)}}</div>
            </div>
            <div class="d-flex flex-column flex-grow-1">
              <mat-card-title class="fs-8 text-secondary fw-bold mb-2 d-flex justify-content-start">{{comment.user.firstName}} {{comment.user.lastName}}</mat-card-title>
              <mat-card-subtitle class="fs-9 mb-0">{{comment.createdDate}}</mat-card-subtitle>
            </div>
            <div class="showActions" *ngIf="!comment.editComment && comment.commentedBy === userId && !lock">
              <mat-card-title class="fs-8 text-secondary fw-bold d-flex justify-content-start mb-0 pt-2">
                <mat-icon class="text-primary fs-7" (click)="editComment(index)">edit</mat-icon>
                <mat-icon class="text-danger fs-7" (click)="deleteComment(index)">delete</mat-icon>
              </mat-card-title>
            </div>
          </mat-card-header>
          <mat-card-content class="mb-0 mt-1">
            <div class="d-flex flex-dir-column">
              <div *ngIf="!comment.editComment">
                <p class="mb-1">
                  {{comment.commentMessage}}
                </p>
              </div>
              <div *ngIf="comment.editComment">
                <mat-form-field class="w-100" [floatLabel]="'never'">
                                <textarea matInput
                                          class="border-0 qs-chat-textarea shadow-none bg-transparent"
                                          [(ngModel)]="comment.commentMessage"
                                          [ngModelOptions]="{standalone: true}"
                                          cdkTextareaAutosize
                                          cdkAutosizeMinRows="1"
                                          cdkAutosizeMaxRows="5"
                                          placeholder="Edit your note">
                                </textarea>
                </mat-form-field>
                <div class="d-flex justify-content-end mb-2">
                  <button mat-button class="p-0 h-rem-6 fs-8 lh-1" (click)="closeUpdateComment(index)">CANCEL</button>
                  <button mat-button cdkFocusInitial class="bg-light-blue text-white p-0 h-rem-6 fs-8 lh-1" (click)="updateComment(index)">
                    <mat-icon *ngIf="loader">
                      <mat-spinner [diameter]="10" color="primary"></mat-spinner>
                    </mat-icon>
                    UPDATE
                  </button>
                </div>
              </div>
            </div>
            <mat-divider></mat-divider>
          </mat-card-content>
        </div>
      </div>
      <div class="px-3">
        <mat-card-content class="mb-0" *ngIf="!lock">
          <div class="d-flex flex-dir-column">
            <div>
              <mat-form-field class="w-100 mt-2" [floatLabel]="'never'">
               
                <textarea matInput [(ngModel)]="postMessage"
                          [ngModelOptions]="{standalone: true}"
                          class="qs-chat-textarea border-0 shadow-none bg-transparent"
                          placeholder="What's on your mind..."
                          cdkTextareaAutosize
                          cdkAutosizeMinRows="1"
                          cdkAutosizeMaxRows="5">
                                </textarea>
              </mat-form-field>
            </div>
            <div class="d-flex justify-content-end mb-2" *ngIf="postMessage.length > 0">
              <button mat-button class="p-0 h-rem-6 fs-7 lh-1" (click)="onCancelPost()">CANCEL</button>
              <button mat-button cdkFocusInitial class="bg-light-blue text-white p-0 h-rem-6 fs-7 lh-1" (click)="onPost()">
                <mat-icon *ngIf="loader">
                  <mat-spinner [diameter]="20" color="primary"></mat-spinner>
                </mat-icon>
                POST
              </button>
            </div>
          </div>
        </mat-card-content>
        <mat-card-content *ngIf="lock && question.comments.length === 0 " class="py-3 text-center">
          No Data
        </mat-card-content>
      </div>
    </mat-card>
  </div>
</div>
